import useStoreAndLanguageParams from '../../core/hooks/useStoreAndLanguageParams';
import useCategory from '../../core/queries/useCategory';
import type { CategoryFilter } from '../types';
import useCancelableQuery from '../../core/hooks/apollo/useCancelableQuery';
import categoryFiltersQuery from './categoryFiltersQuery';

const useCurrentCategoryFilters = ({
    includeValues = false,
    skip = false,
} = {}) => {
    const { language } = useStoreAndLanguageParams();
    const { categoryId } = useCategory();
    const {
        data: { category } = {
            category: { filters: [] },
        },
        error,
    } = useCancelableQuery<{
        category: {
            key: string;
            id: string;
            filters: CategoryFilter[];
        };
    }>(categoryFiltersQuery, {
        variables: {
            language,
            id: categoryId,
            includeValues,
        },
        skip: !categoryId || skip,
        fetchPolicy: 'cache-first',
    });

    if (error) {
        throw error;
    }

    return { category };
};

export default useCurrentCategoryFilters;
